import styled from "styled-components";

export const Container = styled.div``;

export const SamplesOptions = styled.div`
  width: 100%;
  padding-left: 20px;
`;
